import superagent from 'superagent';
import { utcToZonedTime, formatInTimeZone } from "date-fns-tz";
import constants, { DEFAULT_TIMEZONE } from './Constants.js';

export const ANY_VALUE = -999;

let fabricatorSchemas = undefined;
let shopifySchemas = undefined;
let cloudSchemas = undefined;

export async function getFabricatorSchemas() {
    if (!fabricatorSchemas) {
        try {
            const res = await superagent.get("/api/admin/fabricator/schemas2");
            let JobTypes = res.body.JobTypes;
            let JobActions = res.body.JobActions;
            let JobStates = res.body.JobStates;
            let Ipds = res.body.IpdOptions;
            let ScanRequestStates = res.body.ScanRequestStates;
            let BigOrderOrigins = res.body.BigOrderOrigins;
            let BigOrderActions = res.body.BigOrderActions;
            let BigOrderStates = res.body.BigOrderStates;
            let BigProductTypes = res.body.BigProductTypes;
            let AccessoryBigProductTypes = res.body.AccessoryBigProductTypes;
            let BigOrderScanRequestActions = res.body.BigOrderScanRequestActions;
            let BigOrderShipmentHoldReasons = res.body.BigOrderShipmentHoldReasons;
            let BigOrderShippingServiceLevels = res.body.BigOrderShippingServiceLevels;
            let InventoryItemStatuses = res.body.InventoryItemStatuses;
            let BigShipmentStatuses = res.body.BigShipmentStatuses;
            let BigProductTypeCustomsInfo = res.body.BigProductTypeCustomsInfo;

            delete JobTypes[0];
            delete JobActions[0];
            delete JobStates[0];
            delete ScanRequestStates[0];
            delete BigOrderOrigins["Unknown"];
            delete BigOrderActions["Unknown"];
            delete BigOrderStates["Unknown"];
            delete BigProductTypes["Unknown"];
            delete BigOrderScanRequestActions["Unknown"];
            delete BigOrderShipmentHoldReasons["Unknown"];
            delete BigOrderShippingServiceLevels["Unknown"];
            delete InventoryItemStatuses[0];
            delete BigShipmentStatuses[0];

            let JobTypeOptions = Object.keys(JobTypes).map(k => { return { "key": k, "value": JobTypes[k], "text": k } });
            let JobActionOptions = Object.keys(JobActions).map(k => { return { "key": k, "value": JobActions[k], "text": k } });
            let JobStateOptions = Object.keys(JobStates).map(k => { return { "key": k, "value": JobStates[k], "text": `${k}` } });
            let IpdOptions = _.range(55, 75).map(k => { return { "key": k, "value": k, "text": `${k}mm` } });
            let ScanRequestStateOptions = Object.keys(ScanRequestStates).map(k => { return { "key": k, "value": ScanRequestStates[k], "text": `(${k}) ${ScanRequestStates[k]}` } });
            let BigOrderOriginOptions = Object.keys(BigOrderOrigins).map(k => { return { "key": k, "value": BigOrderOrigins[k], "text": k } });
            let BigOrderActionOptions = Object.keys(BigOrderActions).map(k => { return { "key": k, "value": BigOrderActions[k], "text": k } });
            let BigOrderStateOptions = Object.keys(BigOrderStates).map(k => { return { "key": k, "value": BigOrderStates[k], "text": k } });
            let BigProductTypeOptions = Object.keys(BigProductTypes).map(k => { return { "key": k, "value": BigProductTypes[k], "text": k } });
            let BigOrderScanRequestActionsOptions = Object.keys(BigOrderScanRequestActions).map(k => { return { "key": k, "value": BigOrderScanRequestActions[k], "text": k } }); 
            let BigOrderShipmentHoldReasonsOptions = Object.keys(BigOrderShipmentHoldReasons).map(k => { return { "key": k, "value": BigOrderShipmentHoldReasons[k], "text": splitUpperCamelCase(k) } }); 
            let BigOrderShippingServiceLevelsOptions = Object.keys(BigOrderShippingServiceLevels).map(k => { return { "key": k, "value": BigOrderShippingServiceLevels[k], "text": k } });
            let InventoryItemStatusOptions = Object.keys(InventoryItemStatuses).map(k => { return { "key": k, "value": InventoryItemStatuses[k], "text": k } });
            let BigShipmentStatusOptions = Object.keys(BigShipmentStatuses).map(k => { return { "key": k, "value": BigShipmentStatuses[k], "text": k } });

            JobTypeOptions.unshift({ "key": ANY_VALUE, "value": ANY_VALUE, "text": `Any` });
            JobActionOptions.unshift({ "key": ANY_VALUE, "value": ANY_VALUE, "text": `Any` });
            IpdOptions.unshift({ "key": ANY_VALUE, "value": ANY_VALUE, "text": `Any` });
            BigOrderActionOptions.unshift({ "key": `Any`, "value": ANY_VALUE, "text": `Any` });
            ScanRequestStateOptions.unshift({ "key": ANY_VALUE, "value": ANY_VALUE, "text": `Any` });
            BigProductTypeOptions.unshift({ "key": ANY_VALUE, "value": ANY_VALUE, "text": `Any` });
            InventoryItemStatusOptions.unshift({ "key": ANY_VALUE, "value": ANY_VALUE, "text": `Any` });
            BigShipmentStatusOptions.unshift({ "key": ANY_VALUE, "value": ANY_VALUE, "text": `Any` });

            fabricatorSchemas = {
                JobTypes, JobActions, JobStates, Ipds, ScanRequestStates, BigOrderOrigins,
                BigOrderActions, BigOrderStates, BigProductTypes, AccessoryBigProductTypes,
                BigOrderScanRequestActions, BigOrderShipmentHoldReasons, BigOrderShippingServiceLevels,
                InventoryItemStatuses, BigShipmentStatuses, BigProductTypeCustomsInfo,
                BigProductTypeOptions, JobTypeOptions, JobActionOptions, JobStateOptions,
                IpdOptions, ScanRequestStateOptions, BigOrderActionOptions, BigOrderStateOptions,
                BigOrderOriginOptions, BigProductTypeOptions, BigOrderScanRequestActionsOptions, BigOrderShipmentHoldReasonsOptions,
                BigOrderShippingServiceLevelsOptions,
                InventoryItemStatusOptions, BigShipmentStatusOptions
            };
        } catch (err) {
            console.error(err);
        }
    }

    return fabricatorSchemas;
}

export async function getShopifySchemas() {
    if (!shopifySchemas) {
        try {
            const res = await superagent.get("/api/admin/shop/products_snapshot");
            let productVariants = Object.keys(res.body).map(k => { 
                const v = res.body[k];
                const variantId = v.variantId ? v.variantId : k.split(":")[1];
                return { "key": k, "value": variantId, "text": `${v.productTitle} (${v.title})` } 
            });

            shopifySchemas = {
                productVariants
            };
        } catch (err) {
            console.error(err);
        }
    }

    return shopifySchemas;
}

export async function getCloudSchemas() {
    if (!cloudSchemas) {
        try {
            const res = await superagent.get("/cloud/admin/schemas");

            let MicrophonePolicy = res.body.MicrophonePolicy;
            let MovementSoundsPolicy = res.body.MovementSoundsPolicy;
            let DrawingVisibility = res.body.DrawingVisibility;
            let AvatarNameVisibility = res.body.AvatarNameVisibility;
            let PoseVisibility = res.body.PoseVisibility;
            let ToySpawnability = res.body.ToySpawnability;
            let PreferredUserType = res.body.PreferredUserType;
            let RoomType = res.body.RoomType;
            let RoomVisibility = res.body.RoomVisibility;
            let RoomInstancePolicy = res.body.RoomInstancePolicy;

            let MicrophonePolicyOptions = Object.keys(MicrophonePolicy).map(k => { return { "key": k, "value": MicrophonePolicy[k], "text": k } });
            let MovementSoundsPolicyOptions = Object.keys(MovementSoundsPolicy).map(k => { return { "key": k, "value": MovementSoundsPolicy[k], "text": k } });
            let DrawingVisibilityOptions = Object.keys(DrawingVisibility).map(k => { return { "key": k, "value": DrawingVisibility[k], "text": k } });
            let AvatarNameVisibilityOptions = Object.keys(AvatarNameVisibility).map(k => { return { "key": k, "value": AvatarNameVisibility[k], "text": k } });
            let PoseVisibilityOptions = Object.keys(PoseVisibility).map(k => { return { "key": k, "value": PoseVisibility[k], "text": k } });
            let ToySpawnabilityOptions = Object.keys(ToySpawnability).map(k => { return { "key": k, "value": ToySpawnability[k], "text": k } });
            let PreferredUserTypeOptions = Object.keys(PreferredUserType).map(k => { return { "key": k, "value": PreferredUserType[k], "text": k } });
            let RoomTypeOptions = Object.keys(RoomType).map(k => { return { "key": k, "value": RoomType[k], "text": k } });
            let RoomVisibilityOptions = Object.keys(RoomVisibility).map(k => { return { "key": k, "value": RoomVisibility[k], "text": k } });
            let RoomInstancePolicyOptions = Object.keys(RoomInstancePolicy).map(k => { return { "key": k, "value": RoomInstancePolicy[k], "text": k } });

            // Super stupid mapping from admin settings keys to schema options
            //
            // TODO: return this on the schema???
            let AdminSettingsOptions = {
                "microphonePolicy": {
                    optionsKey: "MicrophonePolicyOptions", title: "Microphone Policy"
                },
                "movementSoundsPolicy": {
                    optionsKey: "MovementSoundsPolicyOptions", title: "Movement Sounds Policy"
                },
                "drawingVisibility": {
                    optionsKey: "DrawingVisibilityOptions", title: "Drawing Visibility"
                },
                "avatarNameVisibility": {
                    optionsKey: "AvatarNameVisibilityOptions", title: "Avatar Name Visibility"
                },
                "poseVisibility": {
                    optionsKey: "PoseVisibilityOptions", title: "Pose Visibility"
                },
                "toySpawnability": {
                    optionsKey: "ToySpawnabilityOptions", title: "Toy Spawnability"
                },
                "preferredUserType": {
                    optionsKey: "PreferredUserTypeOptions", title: "Preferred User Type"
                }
            }

            cloudSchemas = {
                MicrophonePolicy, MovementSoundsPolicy, DrawingVisibility, AvatarNameVisibility, 
                PoseVisibility, ToySpawnability, PreferredUserType, RoomType, RoomVisibility, RoomInstancePolicy,
                MicrophonePolicyOptions, MovementSoundsPolicyOptions, DrawingVisibilityOptions, AvatarNameVisibilityOptions,
                PoseVisibilityOptions, ToySpawnabilityOptions, PreferredUserTypeOptions, RoomTypeOptions, RoomVisibilityOptions, RoomInstancePolicyOptions,
                AdminSettingsOptions
            };
        } catch (err) {
            console.error(err);
        }
    }

    return cloudSchemas
}

export async function getEnvironmentOptions () {
    try {
        const res = await superagent.get("/cloud/admin/rooms/environments");
        return res.body.items.map(env => { return { "key": env.id, "value": env.id, "text": env.name } });
    } catch (err) {
        console.error(err);
    }
}

/**
 * Javascript function that splits an "upper camel case" string into the words it contains. 
 * For example if the input is the string "UpperCamelCase", it returns the string "Upper Camel Case". 
 * If the input string is "AsWeGoToBigSur", it returns the string "As We Go To Big Sur".
 * @param {*} str 
 * @returns 
 */
export function splitUpperCamelCase(str) {
    return str.replace(/([A-Z])/g, ' $1').trim();
}

export function CovertDateTimeToShopify(date) {
    const dateTime = new Date(date);
    const zonedTime = utcToZonedTime(dateTime, DEFAULT_TIMEZONE);
    return formatInTimeZone(zonedTime, DEFAULT_TIMEZONE, "yyyy-MM-dd'T'HH:mm:ssXXX");
}
